<template>
    <modal :show.sync="show_modal" :hide-footer="true">
        <div class="table-simple-modal" v-if="approval">
            <b-table-simple responsive bordered>
                <b-tbody>
                    <b-tr>
                        <b-th class="bg-dark text-white py-2" width="150px">Approval ID</b-th>
                        <b-td class="bg-white py-2">#{{approval.approval_id}}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-th class="bg-dark text-white py-2" width="150px">Title</b-th>
                        <b-td class="bg-white py-2">{{ approval.appr_content}}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-th class="bg-dark text-white py-2" width="150px">Requester</b-th>
                        <b-td class="bg-white py-2">{{ approval.created_by_detail.name }}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-th class="bg-dark text-white py-2" width="150px">Requester Remark</b-th>
                        <b-td class="bg-white py-2">{{ approval.appr_remark || '-' }}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-th class="bg-dark text-white py-2" width="150px">Requested Value</b-th>
                        <b-td class="bg-white py-2">
                            <a href="javascript:void(0)" @click="$emit('preview-vps-value', approval.approval_type)" class="text-primary"><i class="fa fa-eye"></i></a>
                        </b-td>
                    </b-tr>
                    <b-tr>
                        <b-th class="bg-dark text-white py-2" width="150px">Requested At</b-th>
                        <b-td class="py-2">{{ approval.created_at | dateTimeFormatString }}</b-td>
                    </b-tr>
                </b-tbody>
            </b-table-simple>
            <b-table-simple responsive bordered v-for="(reviewers, index) in approvalReviewerGroupByOrders" :key="index">
                <b-tbody>
                    <b-tr>
                        <b-th class="bg-dark text-white py-2" width="150px">
                            <span v-if="index !== reviewers.length - 1">Reviewer {{ index+1 }}</span>
                            <span v-else>Approver</span>
                        </b-th>
                        <b-td class="bg-white py-2">
                            <span v-for="(reviewer,index) in reviewers" :key="index">
                                    <span :class="[reviewer.appr_rev_status !== null ? 'font-weight-bold': '']">{{ reviewer.appr_rev_user_detail.name }}</span> 
                                    <span v-if="index !== reviewers.length - 1">, </span>
                                </span>
                        </b-td>
                    </b-tr>
                    <b-tr>
                        <b-th class="bg-dark text-white py-2" width="150px">Remark</b-th>
                        <b-td class="bg-white py-2">
                            <span v-for="(reviewer,index) in reviewers" :key="index">
                                <span v-if="reviewer.appr_rev_remark" class="mb-2"> {{ reviewer.appr_rev_remark || '-' }}</span>
                            </span>
                        </b-td>
                    </b-tr>
                    <b-tr>
                        <b-th class="bg-dark text-white py-2" width="150px">Reviewed At</b-th>
                        <b-td class="bg-white py-2">
                            <span v-for="(reviewer,index) in reviewers" :key="index">
                                <span v-if="reviewer.appr_rev_reviewed_date">{{ reviewer.appr_rev_reviewed_date |  dateTimeFormatString}}</span>
                            </span>
                        </b-td>
                    </b-tr>
                    <b-tr>
                        <b-th class="bg-dark text-white py-2" width="150px">Status</b-th>
                        <b-td class="bg-white py-2">
                            <span v-for="(reviewer,index) in reviewers" :key="index">
                                <span class="text-success font-weight-bold mr-2" v-if="reviewer.appr_rev_status === 1">Approved</span>
                                <span class="text-danger font-weight-bold mr-2" v-if="reviewer.appr_rev_status === 0">Rejected</span>
                            </span>
                        </b-td>
                    </b-tr>  
                </b-tbody>
            </b-table-simple>
            <b-table-simple responsive bordered>
                <b-tbody>
                    <b-tr>
                        <b-th class="bg-dark text-white py-2" width="150px">Final Status</b-th>
                        <b-td class="bg-white py-2">
                            <span class="text-success font-weight-bold mr-2" v-if="approval.appr_final_status === 1">Approved</span>
                            <span class="text-danger font-weight-bold mr-2" v-if="approval.appr_final_status === 0">Rejected</span>
                        </b-td>
                    </b-tr>
                    <b-tr v-if="approval.appr_final_status === 1">
                        <b-th class="bg-dark text-white py-2" width="150px">Final Value</b-th>
                        <b-td class="bg-white py-2">
                            <a href="javascript:void(0)" @click="$emit('preview-vps-value', approval.approval_type)" class="text-primary"><i class="fa fa-eye"></i></a>
                        </b-td>
                    </b-tr>
                </b-tbody>
            </b-table-simple>
        </div>
    </modal>
</template>
<script>
import Modal from "@/components/Modal"

export default {
    props: {
        preview_approval: Boolean,
        approval: Object
    },
    components: {
        Modal
    },
    computed:{
            approvalReviewerGroupByOrders(){
                const groupedArray = this.approval.approval_reviewers.reduce((result, item) => {
                const order = item.app_rev_order;
                if (!result[order]) {
                    result[order] = [];
                }
                result[order].push(item);
                return result;
                }, {});
                
                return Object.values(groupedArray);
            }
        },
    data() {
        return {
            show_modal: false,
            remark: '',
        }
    },
    methods: {
        toggleView() {
            this.show_modal = !this.show_modal;
        }
    },
}
</script>